import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';
import AWS from 'aws-sdk';

function CadLojinha() {
  const { DateTime } = require("luxon");

  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodproduto, setedtcodproduto] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");
  const [edtreferencia, setedtreferencia] = useState("");
  const [edtvalor, setedtvalor] = useState(0);
  const [edtfoto, setedtfoto] = useState("");
  const [edtestoque, setedtestoque] = useState(0);
  const [edtdtvalidade, setedtdtvalidade] = useState("");
  const [edtativo, setedtativo] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const { codassinante, selectedCompany, accessKey } = useAppContext();

  // Configuração da AWS
  AWS.config.update({
    accessKeyId: 'AKIAY3NQW3W4IZFQLWC5', // AccountName
    secretAccessKey: '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', // AccountKey
    region: 'us-east-1', // Certifique-se de que esta é a região correta do bucket S3
  });

  const s3 = new AWS.S3();
  const bucketName = 'isolution'; // BucketName

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const params = {
      Bucket: bucketName,
      Key: `iGame/ImagensProduto/${edtdescricao}_${file.name}`, // ObjectName + Nome do Arquivo
      Body: file,
      ContentType: file.type,
      ACL: 'public-read', // Permissão para tornar o arquivo acessível publicamente
    };

    try {
      // Upload para o S3
      const { Location } = await s3.upload(params).promise();
      setedtfoto(Location); // Armazena o link da imagem no estado edtfoto
      alert("Upload realizado com sucesso!");
    } catch (error) {
      console.error('Erro no upload:', error);
      alert("Erro ao realizar o upload.");
    }
  };

  const handleOpen = (cad) => {
    setedtcodproduto(cad.codproduto);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    Excluir();
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarProduto() {
    api
      .get("v1/cadastro/lojinha", {
        params: {
          busca: abusca,
          codassinante,
          codempresa: selectedCompany
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(
    function () {
      ListarProduto();
    },
    [showform, abusca, selectedCompany]
  );

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/lojinha",
        {
          descricao: edtdescricao,
          referencia: edtreferencia,
          valor: edtvalor,
          foto: edtfoto,
          estoque: edtestoque,
          validade: edtdtvalidade,
          ativo: edtativo,
          excluido: "N",
          codassinante,
          codempresa: selectedCompany
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarProduto();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/lojinha",
        {
          codproduto: edtcodproduto,
          descricao: edtdescricao,
          referencia: edtreferencia,
          valor: edtvalor,
          foto: edtfoto,
          estoque: edtestoque,
          validade: edtdtvalidade,
          ativo: edtativo,
        },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        }
      )
      .then(() => {
        ListarProduto();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/lojinha", {
        params: {
          codproduto: edtcodproduto,
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      })
      .then(() => {
        ListarProduto();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodproduto(0);
    setedtdescricao("");
    setedtreferencia("");
    setedtvalor(0);
    setedtfoto("");
    setedtestoque(0);
    setedtdtvalidade("");
    setedtativo("S");
  }

  function openModalEditar(cad) {
    setshowform(true);
    setnovo(false);

    setedtcodproduto(cad.codproduto);
    setedtdescricao(cad.descricao);
    setedtreferencia(cad.referencia);
    setedtvalor(cad.valor);
    setedtfoto(cad.foto);
    setedtestoque(cad.estoque);

    const dt = DateTime.fromISO(cad.dtvalidade)
      .plus({ hours: 3 })
      .toFormat("yyyy-MM-dd HH:mm");

    setedtdtvalidade(dt);

    setedtativo(cad.ativo);
  }

  function FormataDataHora(props) {
    return props
      ? DateTime.fromISO(props)
        .plus({ hours: 3 })
        .toFormat("dd/MM/yyyy HH:mm:ss")
      : null;
  }

  return (
    <>
      <div className="app-container">
        <div className="container-fluid">
          <div>
            <div>
              <PopUp isOpen={isOpen} onClose={handleClose}>
                <h2>Verificação</h2>
                <p>Tem certeza que deseja excluir esse registro?</p>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button
                      className="btn btn-primary me-2"
                      onClick={handleConfirma}
                    >
                      Sim
                    </button>
                    <button className="btn btn-danger" onClick={handleClose}>
                      Não
                    </button>
                  </div>
                </div>
              </PopUp>
            </div>

            <Modal
              isOpen={showform}
              onRequestClose={closeModal}
              overlayClassName="modal-overlay"
              className="modal-content"
            >
              <div className="container-fluid h-100">
                <div className="row">
                  <h2>Novo Cadastro</h2>
                </div>
                <div className="row">
                  <hr />
                </div>

                <div className="row">
                  <form>
                    <div className="row">
                      <div className="col-sm-5">
                        <label htmlFor="descricao" className="form-label">
                          Descrição
                        </label>
                        <input
                          type="text"
                          id="descricao"
                          className="form-control"
                          placeholder="Descrição"
                          value={edtdescricao}
                          onChange={(e) => setedtdescricao(e.target.value)}
                        />
                      </div>

                      <div className="col-sm-5">
                        <label htmlFor="referencia" className="form-label">
                          Referência
                        </label>
                        <input
                          type="text"
                          id="referencia"
                          className="form-control"
                          placeholder="Referência"
                          value={edtreferencia}
                          onChange={(e) => setedtreferencia(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-4">
                        <label htmlFor="valor" className="form-label">
                          Valor
                        </label>
                        <input
                          type="number"
                          id="valor"
                          className="form-control"
                          placeholder="Valor"
                          value={edtvalor}
                          onChange={(e) => setedtvalor(e.target.valueAsNumber)}
                        />
                      </div>

                      <div className="col-sm-4">
                        <label htmlFor="estoque" className="form-label">
                          Estoque
                        </label>
                        <input
                          type="number"
                          id="estoque"
                          className="form-control"
                          placeholder="Estoque"
                          value={edtestoque}
                          onChange={(e) => setedtestoque(e.target.valueAsNumber)}
                        />
                      </div>

                      <div className="col-sm-4">
                        <label htmlFor="dtvalidade" className="form-label">
                          Dt. Validade
                        </label>
                        <input
                          type="date"
                          id="dtvalidade"
                          className="form-control"
                          placeholder="Dt. Validade"
                          value={edtdtvalidade}
                          onChange={(e) => setedtdtvalidade(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-10">
                        <br />
                        <input type="file" onChange={handleFileUpload} />
                        <p>Link da Foto: <a href={edtfoto} target="_blank" rel="noopener noreferrer">{edtfoto}</a></p>
                      </div>

                      <div className="col-sm-2">
                        <div>
                          <label htmlFor="ativo1" className="form-label">
                            Ativo
                          </label>
                          <br />
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="ativo"
                              value="S"
                              onChange={(e) => setedtativo(e.target.value)}
                              checked={edtativo === "S"}
                            />
                            <label
                              className="form-check-label"
                              for="inlineRadio1"
                            >
                              Sim
                            </label>
                          </div>

                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="ativo"
                              value="N"
                              onChange={(e) => setedtativo(e.target.value)}
                              checked={edtativo === "N"}
                            />
                            <label className="form-check-label" htmlfor="ativo2">
                              Não
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="row">
                  <div className="col-12 mt-3 d-flex justify-content-end">
                    <button className="btn btn-danger ms-4" onClick={closeModal}>
                      Cancelar
                    </button>
                    <button className="btn btn-success ms-4" onClick={Salvar}>
                      Salvar
                    </button>
                  </div>
                </div>
              </div>
            </Modal>
          </div>

          <div className="row">
            <h1 className="ms-4">Cadastro da Lojinha</h1>
            <p className="ms-4">Rotina para cadastrar os produtos da lojinha</p>
            <hr />
          </div>

          <div className="row">
            <div className="col-10">
              <label className="d-block" htmlFor="busca">
                Busque aqui
              </label>
              <input
                type="text"
                placeholder="Buscar por: Código ou descrição"
                name="busca"
                id="busca"
                className="form-control me-3"
                value={abusca}
                onChange={(e) => setabusca(e.target.value)}
              />
            </div>
            <div className="col-2 d-flex justify-content-center">
              <button
                className="btn btn-success btnnovo"
                onClick={() => openModalNovo()}
              >
                Novo
              </button>
            </div>
          </div>

          <div className="row mt-3">
            <hr />
          </div>

          <div className="row">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descrição</th>
                  <th>Referência</th>
                  <th>Valor</th>
                  <th>Estoque</th>
                  <th>Dt. Validade</th>
                  <th className="acao">Ações</th>
                </tr>
              </thead>
              <tbody>
                {lista.map(function (item) {
                  return (
                    <tr key={item.codproduto}>
                      <th>{item.codproduto}</th>
                      <th>{item.descricao}</th>
                      <th>{item.referencia}</th>
                      <th>{item.valor}</th>
                      <th>{item.estoque}</th>
                      <th>{FormataDataHora(item.validade)}</th>
                      <th>
                        <div className="d-flex justify-content-center">
                          <button
                            className="btn fa-regular fa-pen-to-square"
                            onClick={() => openModalEditar(item)}
                          ></button>
                          <button
                            className="btn fa-solid fa-trash"
                            onClick={() => handleOpen(item)}
                          ></button>
                        </div>
                      </th>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan={7}>Quantidade de Registros: {lista.length}</th>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default CadLojinha;
